import { apiClient } from '@/api/client'
import type { HiredCandidate } from '@/features/recruiter/api/hires.api'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

export interface AdminHiresFilters {
  organization_id?: number
  lms_source_id?: number
  academic_phase?: string
  q?: string
}

export interface AdminHiresSummary {
  totalHires: number
  byOrganization: { organizationId: number; organizationName: string; hires: number }[]
  options: {
    organizations: { id: number; name: string }[]
    programs: { id: number; name: string; code: string }[]
    phases: string[]
  }
}

export const adminHiresApi = {
  list: async (params: AdminHiresFilters & { page?: number; per_page?: number }) => {
    const { data } = await apiClient.get<
      ApiSuccessResponse<HiredCandidate[]> & { meta: PaginationMeta }
    >('/admin/hires', { params })
    return { hires: data.data, meta: data.meta }
  },

  summary: async (params: AdminHiresFilters) => {
    const { data } = await apiClient.get<ApiSuccessResponse<AdminHiresSummary>>('/admin/hires/summary', { params })
    return data.data
  },
}
